import JiraIncidentTable from "../JiraIncidentTable";
import {
  CHART_FILTERED_LIST,
  CLEAR_JIRA_INCIDENT_TABLE_FILTERS,
  CLEAR_SELECTED_INCIDENT,
  MDR_DASHBOARD_LOADER,
  SET_INCIDENT_TABLE_DATA,
  SET_INCIDENT_TABLE_LOADER,
  SET_JIRA_INCIDENT_TABLE_FILTER,
  SET_JIRA_INCIDENT_TABLE_FILTER_OPTIONS,
  SET_JIRA_INCIDENT_TABLE_LOADER,
  SET_MDR_DASHBOARD_FROM_TIME_STAMP,
  SET_MDR_DASHBOARD_INCIDENT_LIST,
  SET_MDR_DASHBOARD_INCIDENT_SUMMARY,
  SET_MDR_DASHBOARD_OVERVIEW_COUNT,
  SET_MDR_DASHBOARD_TO_TIME_STAMP,
  SET_SELECTED_INCIDENT,
  SET_TABLE_DATA_JIRA,
} from "../mdrConstants";

const initialState = {
  fromTimeStamp: null,
  toTimeStamp: null,
  loader: false,
  mdrDashboardOverviewCount: {},
  mdrDashboardIncidentList: [],
  mdrDashboardIncidentSummary: [],
  selectedIncident: [],
  incidentsTableData: {
    data: [],
    totalCount: 0,
  },
  incidentTableLoader: false,
  chartFilteredList: [],
  JiraIncidentTableData: [],
  JiraIncidentTableFilter: {},
  JiraIncidentTableFilterOptions: {},
  JiraIncidentTableLoader: false,
};

export const mdrReducer = (state = initialState, action) => {
  switch (action.type) {
    case MDR_DASHBOARD_LOADER: {
      return {
        ...state,
        loader: action.payload,
      };
    }
    case SET_MDR_DASHBOARD_FROM_TIME_STAMP: {
      return {
        ...state,
        fromTimeStamp: action.payload,
      };
    }
    case SET_MDR_DASHBOARD_TO_TIME_STAMP: {
      return {
        ...state,
        toTimeStamp: action.payload,
      };
    }
    case SET_MDR_DASHBOARD_OVERVIEW_COUNT: {
      return {
        ...state,
        mdrDashboardOverviewCount: action.payload,
      };
    }
    case SET_MDR_DASHBOARD_INCIDENT_LIST: {
      return {
        ...state,
        mdrDashboardIncidentList: action.payload,
      };
    }
    case SET_MDR_DASHBOARD_INCIDENT_SUMMARY: {
      return {
        ...state,
        mdrDashboardIncidentSummary: action.payload,
      };
    }
    case SET_TABLE_DATA_JIRA: {
      return {
        ...state,
        JiraIncidentTableData: action.payload,
      };
    }
    case SET_SELECTED_INCIDENT: {
      const incidentType = action.payload;
      const isAlreadySelected = state.selectedIncident.includes(incidentType);

      return {
        ...state,
        selectedIncident: isAlreadySelected
          ? state.selectedIncident.filter((i) => i !== incidentType) // remove if exists
          : [...state.selectedIncident, incidentType], // add if not exists
      };
    }
    case SET_INCIDENT_TABLE_DATA: {
      return {
        ...state,
        incidentsTableData: action.payload,
      };
    }
    case SET_INCIDENT_TABLE_LOADER: {
      return {
        ...state,
        incidentTableLoader: action.payload,
      };
    }
    case SET_JIRA_INCIDENT_TABLE_FILTER: {
      const { key, values, filters } = action.payload;

      if (filters) {
        return {
          ...state,
          JiraIncidentTableFilter: filters,
        };
      }

      return {
        ...state,
        JiraIncidentTableFilter: {
          ...state.JiraIncidentTableFilter,
          [key]: values,
        },
      };
    }

    case SET_JIRA_INCIDENT_TABLE_FILTER_OPTIONS: {
      const { options } = action.payload;

      return {
        ...state,
        JiraIncidentTableFilterOptions: {
          ...state.JiraIncidentTableFilterOptions,
          ...options,
        },
      };
    }

    case SET_JIRA_INCIDENT_TABLE_LOADER: {
      return {
        ...state,
        JiraIncidentTableLoader: action.payload,
      };
    }

    case CHART_FILTERED_LIST: {
      return {
        ...state,
        chartFilteredList: action.payload,
      };
    }
    case CLEAR_SELECTED_INCIDENT: {
      return {
        ...state,
        selectedIncident: [],
      };
    }
    case CLEAR_JIRA_INCIDENT_TABLE_FILTERS: {
      return {
        ...state,
        JiraIncidentTableFilter: {},
      };
    }

    default:
      return state;
  }
};
